export default __webpack_public_path__ + "static/media/schools-large.3a313b50.svg";